<div *ngIf="isBusy" 
    class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" 
    style="background: rgba(255,255,255,0.5); z-index: 10;">
    <fa-icon [icon]="faSpinner" [spin]="true" size="5x"></fa-icon>
</div>

<div class="modal-header">
    <h4 class="modal-title" translate>New vessel visit</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-4">
            <app-control label='Vessel' [(ngModel)]="model.vesselId" type="codelist"
                codelist="ApprovedVessel" [required]="true" [useCache]="false">
            </app-control>
        </div>

        <div class="col-4">
            <app-control label='Last Port Of Departure' type="codelist" codelist="Port"
                [(ngModel)]="model.lastPortOfDepartureId">
            </app-control>
        </div>

        <div class="col-4">
            <app-control label='Port Of Arrival' type="codelist" codelist="Port" 
                initialValue="ALDRZ"
                isDisabled="true"
                [(ngModel)]="model.portOfArrival">
            </app-control>
        </div>
    </div>
    
    <div class="row">    
        <div class="col-4">
            <app-control label='Terminal Operator' type="codelist" codelist="PortFacility"
                [(ngModel)]="model.terminalOperatorId" [required]="true">
            </app-control>
        </div>

        <div class="col-4">
            <app-control label='ETA' type="datetime" [(ngModel)]="model.eta" [required]="true">
            </app-control>
        </div>

        <div class="col-4">
            <app-control label='ETD' [(ngModel)]="model.etd" type="datetime" [required]="true" 
                [disabledDates]="etdDisabledDates">
            </app-control>
        </div>
    </div>

    <div class="row">
        <div class="col-4">
            <app-control label='Call Purpose' type="codelist" codelist="CallPurpose"
                [(ngModel)]="model.callPurposeId" [required]="true">
            </app-control>
        </div>

        <div class="col-4">
            <app-control label='Pilot' type="codelist" codelist="Pilot" [(ngModel)]="model.pilotId"
                [required]="true"></app-control>
        </div>

        <div class="col-4">
            <app-control label='Arrival Agent' [(ngModel)]="model.arrivalAgentId" type="select"
                [options]="cargoAgentOptions" [required]="true"></app-control>
        </div>        
    </div>

    <div class="row">
        <div class="col-4">
            <app-control label='Departure Agent' [(ngModel)]="model.departureAgentId" type="select"
                [options]="cargoAgentOptions" [required]="true"></app-control>
        </div>

        <div class="col-4">
            <app-control label='Arrival Draft' type="number" [(ngModel)]="model.arrivalDraft"
                format="n2">
            </app-control>
        </div>
        <div class="col-4">
            <app-control label='Departure Draft' type="number" [(ngModel)]="model.departureDraft"
                format="n2">
            </app-control>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary" (click)="activeModal.close()" translate>Back</button>
    <button class="btn btn-primary" (click)="confirm()" translate [disabled]="isValid">Save</button>
</div>
